import "./Hero.css";
import ButtonV2 from "../../components/ButtonV2";
import { Link } from "react-router-dom";

const Hero = (props) => {
  return (
    <>
      <div
        className="hero"
        style={{
          backgroundImage: `linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.7) 20%, rgba(255,255,255,0.7) 40%, rgba(255,255,255,0.7) 80%, rgba(255,255,255,1) 100%), url('${props.background}')`,
        }}
      >
        <div className="d-flex flex-column align-items-center justify-content-center">
          <h1 className="text-center hero-title p-3">{props.title}</h1>
          <h3 className="text-center hero-text p-3">{props.text}</h3>
          {/* odkazy krome posledniho */}
          <div className="d-flex mt-3">
            {props.links.slice(0, -1).map((link) => (
              <div key={link.id} className="m-2">
                <Link to={link.Odkaz}>
                  <ButtonV2 text={link.Text} />
                </Link>
              </div>
            ))}
          </div>
          {/* (virtualni prohlidka) */}
          {props.links.length > 0 && (
            <div className="mt-2 mb-2">
              <Link to={props.links[props.links.length - 1].Odkaz}>
                <ButtonV2 text={props.links[props.links.length - 1].Text} />
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default Hero;

